import React from 'react';
import {Field} from 'redux-form/immutable';
import {SelectField, TextField, TextAreaField} from 'redux-form-antd'
import {
    nullValue1,
    required
} from "../validDesc";
const formItemLayout = {
    labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
    },
    wrapperCol: {
        xs: { span: 24 },
        sm: { span: 19 },
    },
};
const Disease = props => {
    const default_select = [
        {
            value: '-1',
            label: '請選擇'
        },
        {
            value: '1',
            label: '無'
        },
        {
            value: '2',
            label: '有-治療中'
        },
        {
            value: '3',
            label: '有，已痊癒'
        }
    ]
    const default_yes_no_select = [
        {
            value: '-1',
            label: '請選擇'
        },
        {
            value: '1',
            label: '否'
        },
        {
            value: '2',
            label: '是'
        }
    ]
    const diabetes_select = [
        {
            value: '-1',
            label: '請選擇'
        },
        {
            value: '1',
            label: '無'
        },
        {
            value: '2',
            label: '有-第一型'
        },
        {
            value: '3',
            label: '有-第二型'
        },
    ]
    return (
        <div>
            <h3>學童健康狀況調查</h3>
            <div className='ml-20'>
                {/*<Field {...formItemLayout} validate={[required, nullValue1]} component={SelectField} label='目前沒有以下疾病及問題'*/}
                {/*       options={default_select} name="disease_1" type="text" disabled={false}></Field>*/}
                <Field {...formItemLayout} validate={[required, nullValue1]} component={SelectField} label='心臟病'
                       options={default_select} name="disease_2" type="text" disabled={false}></Field>
                <Field {...formItemLayout} validate={[required, nullValue1]} component={SelectField} label='糖尿病'
                       options={diabetes_select} name="disease_3" type="text" disabled={false}></Field>
                <Field {...formItemLayout} validate={[required, nullValue1]} component={SelectField} label='腎臟病'
                       options={default_select} name="disease_4" type="text" disabled={false}></Field>
                <Field {...formItemLayout} validate={[required, nullValue1]} component={SelectField} label='血友病'
                       options={default_select} name="disease_5" type="text" disabled={false}></Field>
                <Field {...formItemLayout} validate={[required, nullValue1]} component={SelectField} label='蠶豆症'
                       options={default_select} name="disease_6" type="text" disabled={false}></Field>
                <Field {...formItemLayout} validate={[required, nullValue1]} component={SelectField} label='肺結核'
                       options={default_select} name="disease_7" type="text" disabled={false}></Field>
                <Field {...formItemLayout} validate={[required, nullValue1]} component={SelectField} label='氣喘'
                       options={default_select} name="disease_8" type="text" disabled={false}></Field>
                <Field {...formItemLayout} validate={[required, nullValue1]} component={SelectField} label='肝炎（A、B、C、D、E）'
                       options={default_select} name="disease_9" type="text" disabled={false}></Field>
                <Field {...formItemLayout} validate={[required, nullValue1]} component={SelectField} label='癲癇'
                       options={default_select} name="disease_10" type="text" disabled={false}></Field>
                <Field {...formItemLayout} component={TextField} label="有無過敏物質（請寫出名稱）"
                       name="disease_11" type="text"></Field>
                <Field {...formItemLayout} component={TextField} label="重大手術名稱（請寫出名稱）"
                       name="disease_12" type="text"></Field>
                <Field {...formItemLayout} validate={[required, nullValue1]} component={SelectField} label='貧血'
                       options={default_select} name="disease_13" type="text" disabled={false}></Field>
                <Field {...formItemLayout} validate={[required, nullValue1]} component={SelectField} label='紅斑性狼瘡'
                       options={default_select} name="disease_14" type="text" disabled={false}></Field>
                <Field {...formItemLayout} validate={[required, nullValue1]} component={SelectField} label='關節炎'
                       options={default_select} name="disease_15" type="text" disabled={false}></Field>
                <Field {...formItemLayout} validate={[required, nullValue1]} component={SelectField} label='心理或精神性疾病'
                       options={default_select} name="disease_16" type="text" disabled={false}></Field>
                <Field {...formItemLayout} validate={[required, nullValue1]} component={SelectField} label='癌症(腫瘤)'
                       options={default_select} name="disease_17" type="text" disabled={false}></Field>
                <Field {...formItemLayout} component={TextField} label="罕見疾病"
                       name="disease_18" type="text"></Field>
                <Field {...formItemLayout} component={TextField} label="其他"
                       name="disease_19" type="text"></Field>
                <Field {...formItemLayout} validate={[required, nullValue1]} component={SelectField} label='以上疾病治療中'
                       options={default_yes_no_select} name="disease_20" type="text" disabled={false}></Field>
                <Field {...formItemLayout} validate={[required, nullValue1]} component={SelectField} label='以上疾病已痊癒'
                       options={default_yes_no_select} name="disease_21" type="text" disabled={false}></Field>
                <Field component={TextAreaField}
                       label='上述疾病，特別需要注意事項：' name="disease_remark" rows="3"/>
            </div>
        </div>
    )
}

export default Disease



// WEBPACK FOOTER //
// ./src/dashboards_redux/containers/HealthQuestionnaireContaioner/HealthQuestionnaireForm/Disease.jsx